(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PainelUsuariosCtrl', PainelUsuariosController);

  PainelUsuariosController.$inject = [
    '$scope',
    'LoadingService',
    'TrackingService',
    '$routeParams',
    '$route',
    'MessagesService',
    'VisitaCampoService',
    'LeafletService',
    'MapaService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function PainelUsuariosController($scope, LoadingService, TrackingService,
    $routeParams, $route, MessagesService,
    VisitaCampoService, LeafletService, MapaService) {
    const vm = this;
    let willChangePropriedade = false;

    //////////////////////////////////////////
    // Controller data
    vm.users = [];
    vm.search = null;
    vm.selections = $routeParams.selections ? JSON.parse(atob($routeParams.selections)) : {};

    //////////////////////////////////////////
    // Bindable functions
    vm.expandUser = expandUser;
    vm.showTracking = showTracking;
    vm.refresh = refresh;
    vm.isRecent = isRecent;

    //////////////////////////////////////////
    // Function declarations

    function loadUsers() {
      LoadingService.showLoading();
      return TrackingService.lastSendingUsers().then(({ data }) => {
        vm.users = (data || []).map((user) => {
          user.open = user.id in vm.selections;
          return user;
        });
      })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível buscar a lista de usuários.');
        })
        .finally(LoadingService.hideLoading);
    }

    function expandUser(event, user) {
      event.stopPropagation();
      event.preventDefault();
      const selections = angular.copy(vm.selections);
      if (user.id in selections) {
        delete selections[user.id];
      } else {
        selections[user.id] = [];
      }
      updateRoute(selections);
    }

    function loadUserGlebas(user) {
      if (!user.glebas) {
        user.glebas = [];
        const filters = {
          data: user.ultimo_envio,
          usuario: user.id
        };

        LoadingService.showLoading();
        return TrackingService.getGlebasVisitadas(filters).then(({ data }) => {
          user.glebas = data || [];
          user.glebas.map((gleba) => {
            gleba.selected = user.open && vm.selections[user.id].includes(gleba.gleba.id);
            if (gleba.selected) {
              loadGlebaTrackings(user, gleba);
            }
            return gleba;
          });
          return user.glebas;
        })
          .finally(LoadingService.hideLoading);
      }
    }

    function showTracking(user, gleba) {
      const selections = angular.copy(vm.selections);
      if (gleba.selected) {
        selections[user.id].splice(selections[user.id].indexOf(gleba.gleba.id), 1);
      } else {
        selections[user.id].push(gleba.gleba.id);
      }
      updateRoute(selections);
    }

    function loadGlebaTrackings(user, gleba) {
      if (checkPropriedade(gleba, user)) {
        const filters = getGlebaFilters(user, gleba);
        LoadingService.showLoading();
        gleba.loading = true;
        return VisitaCampoService.newGetTrackingsDayGleba(filters)
          .then((trackings) => {
            if (trackings.length === 1 && trackings[0].path.length < 4) {
              showTracking(user, gleba); // desativa gleba
              return MessagesService.alert('Pontos insuficientes para desenhar o caminhamento.');
            }
            return makeGlebaTrackings(gleba, user, trackings);
          })
          .catch((error) => {
            console.error(error);
            MessagesService.alert('Falha ao recuperar caminhamento.');
          })
          .finally(() => {
            LoadingService.hideLoading();
            gleba.loading = false;
          });
      }
    }

    function getGlebaFilters(user, gleba) {
      return {
        usuario: user.id,
        gleba: gleba.gleba,
        dia: moment(user.ultimo_envio).format(MOMENT_DATE_ENGLISH_FORMAT),
        cor: `#${user.cor}`
      };
    }

    function checkPropriedade(gleba, user) {
      if ($scope.$root.currentPropriedade.id !== +gleba.propriedade.id) {
        const propriedade = _.find($scope.$root.propriedades, { id: +gleba.propriedade.id });
        if (!propriedade) {
          showTracking(user, gleba); // desativa gleba
          return MessagesService.alert(`
            Falha ao carregar dados, verifique se você possui
            permissão para visualizar dados da propriedade ${gleba.propriedade.descricao}.
          `);
        }
        // Tira da seleção as glebas marcadas que não estão presentes na nova propriedade
        const selections = {
          [user.id]: [gleba.gleba.id]
        };
        $route.updateParams({
          propriedade: propriedade.id,
          selections: btoa(JSON.stringify(selections))
        });
        willChangePropriedade = true;
        return false;
      }
      return true;
    }

    function makeGlebaTrackings(gleba, user, trackings) {
      gleba.trackings = trackings.map((tracking) => {
        tracking.options = {
          color: `#${user.cor}`,
          opacity: 0.7
        };
        tracking.path = tracking.path.map((path) => [path.lat, path.lng]);
        return createDecoratedPolyline(LeafletService.createPolyline(tracking), user);
      });
      const start = gleba.trackings[0].getLatLngs();
      const end = gleba.trackings.slice(-1)[0].getLatLngs();
      gleba.startEndMarkers = MapaService.createStartEndMarkers({
        latitude: start[0].lat,
        longitude: start[0].lng
      }, {
        latitude: end[0].lat,
        longitude: end[0].lng
      });
      if (gleba.selected) {
        renderTrackings();
      }
      return gleba;
    }

    function createDecoratedPolyline(polyline, user) {
      const decorator = L.polylineDecorator(polyline, {
        patterns: [
          {
            offset: 10,
            repeat: 25,
            symbol: L.Symbol.arrowHead({
              pixelSize: 7,
              polygon: false,
              pathOptions: {
                stroke: true,
                color: `#${user.cor}`
              }
            })
          }
        ]
      });
      polyline.decorator = decorator;
      return polyline;
    }

    function renderTrackings() {
      if (!willChangePropriedade) {
        const resources = vm.users.reduce((res, user) => {
          if (user.open) {
            user.glebas.forEach((gleba) => {
              if (gleba.selected && gleba.trackings) {
                res.trackings = res.trackings.concat(gleba.trackings);
                res.markers = res.markers.concat(gleba.startEndMarkers);
              }
            });
          }
          return res;
        }, {
          trackings: [],
          markers: []
        });
        $scope.$emit('setPolylines', resources.trackings);
        $scope.$emit('setMarkers', resources.markers.map((m) => ({
          leafletMarker: m
        })));
      }
    }

    function updateRoute(selections) {
      selections = btoa(JSON.stringify(selections || {}));
      $route.updateParams({
        selections
      });
    }

    function answerToRouteUpdates() {
      vm.users.forEach((user) => {
        user.open = user.id in vm.selections;

        if (user.open && !user.glebas) {
          return loadUserGlebas(user);
        }

        (user.glebas || []).forEach((gleba) => {
          gleba.selected = user.open && vm.selections[user.id].includes(gleba.gleba.id);
          if (gleba.selected && !gleba.trackings) {
            return loadGlebaTrackings(user, gleba);
          }
        });
      });
      renderTrackings();
    }

    function refresh() {
      updateRoute({});
      vm.users = [];
      loadUsers();
    }

    function isRecent(user) {
      return moment().isSame(user.ultimo_envio, 'day');
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize
      .then(() => {
        if (!$scope.$root.permissions.painelUsuario.canRead) {
          MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
          $route.updateParams({
            sidebar: null
          });
          throw new Error('stop loading');
        }
        return loadUsers();
      })
      .then(() => answerToRouteUpdates())
      .catch((error) => {
        if (error.message !== 'stop loading') {
          console.error(error);
          MessagesService.alert('Erro ao carregar usuários');
        }
      });

    $scope.$on('$routeUpdate', () => {
      if ($routeParams.selections) {
        vm.selections = JSON.parse(atob($routeParams.selections));
      } else {
        vm.selections = {};
      }
      answerToRouteUpdates();
    });

    $scope.$on('$destroy', () => {
      $scope.$emit('clearPolylines');
      $scope.$emit('setMarkers', []);
      if (!willChangePropriedade) {
        $route.updateParams({
          selections: null
        });
      }
    });
  }
}());
